import { render, staticRenderFns } from "./PlanoRead.vue?vue&type=template&id=52987288&"
import script from "./PlanoRead.vue?vue&type=script&lang=js&"
export * from "./PlanoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports